<script lang="ts">
    type Padding = "top" | "both" | "bottom" | "none";
    export let background : "navy" | "grey" | "white" | "lightblue" | "midnight" | "cerulean" | "transparent" | 'lightgrey' = "navy";
    export let mobileBackgroundColor : "navy" | "grey" | "white" | "lightblue" | "midnight" | "cerulean" | "transparent" | 'lightgrey' = background;
    export let padding : Padding = "both"
    export let backgroundImage : string = "";
</script>
<div
    class="container"
    class:navy="{background === 'navy'}"
    class:grey="{background === 'grey'}"
    class:white="{background === 'white'}"
    class:lightblue="{background === 'lightblue'}"
    class:cerulean="{background === 'cerulean'}"
    class:midnight="{background === 'midnight'}"
    class:transparent="{background === 'transparent'}"
    class:lightgrey="{background === 'lightgrey'}"
    class:paddingTop="{padding === 'top'}"
    class:paddingBottom="{padding === 'bottom'}"
    class:paddingNone="{padding === 'none'}"
    class:navyMobile="{mobileBackgroundColor === 'navy'}"
    class:ceruleanMobile="{background === 'cerulean'}"
    class:greyMobile="{mobileBackgroundColor === 'grey'}"
    class:whiteMobile="{mobileBackgroundColor === 'white'}"
    class:lightblueMobile="{mobileBackgroundColor === 'lightblue'}"
    class:midnightMobile="{mobileBackgroundColor === 'midnight'}"
    style="{backgroundImage && 'background-image:url(' + backgroundImage + ');'}"
>
    <slot></slot>
</div>


<style lang="postcss">

    @import '../../styles/_mixins.css';

    .container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding:120px 0px;
        width:100%;
        background-size:cover;
        background-position: top;
        background-repeat: no-repeat;
        border:none;
        overflow-x: hidden;
        position: relative;
        flex-direction: column;

        @mixin screen-lg {
            background-position: top;
            padding:120px 80px;
        }

        @mixin screen-md {
            padding:100px 60px;
            background-size: cover;
            align-items:flex-start;
        }

        @mixin screen-sm {
            padding:60px 24px;
            background-image: none !important;
            background-color: var(--mobileBackgroundColor);
        }
    }

    .navy {
        background-color: var(--color_offerzen_navy);
    }

    .navyMobile {
        @mixin screen-sm {
            background-color: var(--color_offerzen_navy);
        }
    }

    .cerulean {
        background-color: var(--color_offerzen_cerulean);
    }

    .ceruleanMobile {
        @mixin screen-sm {
            background-color: var(--color_offerzen_cerulean);
        }
    }

    .grey {
        background-color: var(--color_grey);
    }

    .greyMobile {
        @mixin screen-sm {
            background-color: var(--color_grey);
        }
    }

    .white {
        background-color: var(--color_white);
    }

    .whiteMobile {
        @mixin screen-sm {
            background-color: var(--color_white);
        }
    }

    .lightblue {
        background-color: var(--color_offerzen_lightblue_secondary)
    }

    .lightblueMobile {
        @mixin screen-sm {
            background-color: var(--color_offerzen_lightblue_secondary);
        }
    }

    .midnight {
        background-color: var(--color_offerzen_midnight);
    }

    .midnightMobile {
        @mixin screen-sm {
            background-color: var(--color_offerzen_midnight);
        }
    }

    .transparent {
        background-color:transparent;
    }

    .lightgrey {
        background-color: #EEF3F6;
    }

    .paddingTop {
        padding:120px 0 0;

        @mixin screen-lg {
            padding:120px 80px 0;
        }

        @mixin screen-md {
            padding:100px 60px;
        }

        @mixin screen-sm {
            padding:60px 24px;
        }
    }

    .paddingBottom {
        padding:0 0 120px;

        @mixin screen-lg {
            padding:0 0 120px;
        }

        @mixin screen-md {
            padding:100px 60px;
        }

        @mixin screen-sm {
            padding:60px 24px;
        }
    }

    .paddingNone {
        padding:0;
    }

</style>